module.exports = __webpack_public_path__ + "static/media/ss2020_kaisa_1920x1080.bbdad800.mp4";